import { createSlice } from "@reduxjs/toolkit";
import { AddDepartment, UpdateDepartment, GetDepartmentList } from "services/other/department.service";
import { toast } from 'react-toastify';

export const departmentAddSlice = createSlice({
  name: "departmentAdd",
  initialState: {
    departmentAdd: {},
    departmentAddLoading: false,
    departmentAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddDepartment.pending, (state) => {
      // toast.loading('We are adding the department 🤯')
      state.departmentAddLoading = true
    });

    builder.addCase(AddDepartment.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New department added successfully 👌');

      state.departmentAdd = action.payload
      state.departmentAddLoading = false
      state.departmentAddError = null
    });

    builder.addCase(AddDepartment.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the department 😣")

      state.departmentAddLoading = false
      state.departmentAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const departmentUpdateSlice = createSlice({
  name: "departmentUpdate",
  initialState: {
    departmentUpdate: {},
    departmentUpdateLoading: false,
    departmentUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateDepartment.pending, (state) => {
      // toast.loading('We are updating the department 🤯')
      state.departmentUpdateLoading = true
    });

    builder.addCase(UpdateDepartment.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.departmentUpdate = action.payload
      state.departmentUpdateLoading = false
      state.departmentUpdateError = null
    });

    builder.addCase(UpdateDepartment.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the department 😣")

      state.departmentUpdateLoading = false
      state.departmentUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});


export const departmentListSlice = createSlice({
  name: "departmentList",
  initialState: {
    departmentList: [],
    departmentListLoading: false,
    departmentListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetDepartmentList.pending, (state) => {
      state.departmentListLoading = true
    });

    builder.addCase(GetDepartmentList.fulfilled, (state, action) => {
      toast.dismiss();

      state.departmentList = action.payload
      state.departmentListLoading = false
      state.departmentListError = null
    });

    builder.addCase(GetDepartmentList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the department 😣")

      state.departmentListLoading = false
      state.departmentListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});
